

// LIVE
const baseUrl = "https://api.equityresearchmart.in:443";

// LOCAL
// const baseUrl = "http://localhost:5217";

const appApiEndPoints = {
  recaptchaVerify: `${baseUrl}/api/Recaptcha/verify`,
};

export default appApiEndPoints;
